<template>
  <div class="offices-information-page text-center">
    <TopMenu
      :title="$t('CONTACT_US.PAGE_LABEL')"
      back-to="/dashboard"
      dark-background/>
    <div class="container-fluid content">
      <div class="row-item-transparent-with-border mt-3 mb-4 pr-4 pl-4 text-left">
        <h3>{{ $t('SIDEMENU.OFFICE_COORDINATE') }}</h3>
      </div>
      <div class="row-item-transparent-with-border mb-4 pb-3 pr-4 pl-4">
        <div class="row">
          <div class="col-4">
            <a
              v-if="officesInformation.email"
              :href="'mailto:' + officesInformation.email"
              target="_blank">
              <span class="filler"/>
              <i class="fas fa-envelope"/>
              <div>{{ officesInformation.email }}</div>
            </a>
          </div>
          <div class="col-4">
            <a
              v-if="officesInformation.webSite"
              :href="getWebsiteUrl(officesInformation.webSite)"
              target="_blank">
              <span class="filler"/>
              <i class="far fa-globe"/>
              <div>{{ getWebsiteText(officesInformation.webSite) }}</div>
            </a>
          </div>
          <div class="col-4">
            <a
              v-if="officesInformation.facebook"
              :href="getWebsiteUrl(officesInformation.facebook)"
              target="_blank">
              <span class="filler"/>
              <i class="fab fa-facebook-f"/>
              <div>Facebook</div>
            </a>
          </div>
        </div>
      </div>
      <div
        v-for="(office, index) in officesInformation.offices"
        :key="index"
        class="row-item-transparent-with-border mb-4 pb-3 pr-4 pl-4 text-left">
        <office-information :office="office"/>
      </div>
    </div>
    <BottomMenu />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';
import OfficeInformation from '@/components/Information/OfficeInformation';
import UrlHelper from '@/helpers/url-helper';

export default {
  name: 'ContactUs',
  components: {
    TopMenu,
    BottomMenu,
    OfficeInformation,
  },
  mixins: [UrlHelper],
  computed: {
    ...mapState('contactUs', ['officesInformation']),
  },
  watch: {},
  created() {
    this.$store.dispatch('contactUs/getOfficesInformation');
  },
  methods: {},
};
</script>

<style scoped lang="scss">
div {
  &.offices-information-page {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
}
.filler {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  z-index: 1;
}
a {
  text-decoration: none;
}
a:hover {
  color: $primary;
}
</style>
